import * as React from "react";
import {
	Container,
	Logo,
	LogoPicture,
	LoadingText,
} from "./AppPreloader.styled";

export const AppPreloader = () => {
	return (
		<Container>
			<LogoPicture>
				<source
					type="image/webp"
					srcSet="
						/images/logotype/common-big.webp 1x,
						/images/logotype/common-big@2x.webp 2x
					"
				/>

				<Logo
					src="/images/logotype/common-big.png"
					srcSet="
						/images/logotype/common-big.png 1x,
						/images/logotype/common-big@2x.png 2x
					"
					alt="Loading Musicabinet"
					width={382}
					height={80}
				/>
			</LogoPicture>

			<LoadingText>
				Loading
			</LoadingText>
		</Container>
	);
};
